import { createStore } from '@aibees/shared/store';
import { isEqual } from 'lodash-es';
import type { SearchHistoryStoreData as StoreData } from './types';

const initialScopeState = () => ({
  history: [{}] as Record<string, string>[],
  current: 0,
});

const useSearchHistoryStore = createStore<StoreData>(
  'search-history',
  (set, get) => ({
    historyByScope: {
      company: initialScopeState(),
      people: initialScopeState(),
      employees: initialScopeState(),
    },

    add: (scope, item) => {
      set((state) => {
        const scopeState = state.historyByScope[scope];
        const { history, current } = scopeState;
        if (!isEqual(item, history[history.length - 1])) {
          return {
            historyByScope: {
              ...state.historyByScope,
              [scope]: {
                history: [...history, item],
                current: current + 1,
              },
            },
          };
        }
        return state;
      });
    },

    undo: (scope) =>
      set((state) => {
        const scopeState = state.historyByScope[scope];
        const { current } = scopeState;
        return {
          historyByScope: {
            ...state.historyByScope,
            [scope]: {
              ...scopeState,
              current: current ? current - 1 : 0,
            },
          },
        };
      }),

    redo: (scope) =>
      set((state) => {
        const scopeState = state.historyByScope[scope];
        const { history, current } = scopeState;
        return {
          historyByScope: {
            ...state.historyByScope,
            [scope]: {
              ...scopeState,
              current: current + 1 < history.length ? current + 1 : current,
            },
          },
        };
      }),

    reset: (scope) =>
      set((state) => ({
        historyByScope: {
          ...state.historyByScope,
          [scope]: initialScopeState(),
        },
      })),

    resetTo: (scope, item) =>
      set((state) => ({
        historyByScope: {
          ...state.historyByScope,
          [scope]: { history: [item], current: 0 },
        },
      })),

    getHistory: (scope) => get().historyByScope[scope].history,
    getCurrent: (scope) => get().historyByScope[scope].current,
  })
);

export default useSearchHistoryStore;
